// Category browser functionality
// Depends on jQuery
(function ($) {

    const defaultEquals = (category1Id, category2Id) => category1Id == category2Id;

    $.fn.treeExplorer = function (options) {

        // This is the easiest way to have default options
        const settings = $.extend({
            // These are the defaults
            autoInit: true,
            addCheckboxesToLeafsOnly: false,
            allowIndependentSelection: false,
            maxSelectionLength: 0,
            equalsFunction: defaultEquals
        }, options);

        const self = this;
        const categoryEquals = settings.equalsFunction;

        // When a category's selection change, should other selections get recalculated?
        // They should, but only when the category browser is open.
        // When it closes, setAllowRecalculation(false) should be called.
        // When it reopens, setAllowRecalculation(true) should be called.
        let allowRecalculation = true;
        self.setAllowRecalculation = function (boolValue) {
            allowRecalculation = boolValue;
        };
        const recalculate = function ($parentElement, allCategories, categoriesWithChanges) {

            if (!allowRecalculation) {
                return;
            }

            if (!categoriesWithChanges) {
                categoriesWithChanges = [];
            }

            if (!settings.allowIndependentSelection) {
                recalculateSelections($parentElement, allCategories, categoriesWithChanges);
            }
            recalculateHasSelectedAncestor($parentElement, allCategories);
            recalculateHasSelectedChild($parentElement, allCategories);

            if (categoriesWithChanges.length) {
                $(self).trigger('selectionChange', [categoriesWithChanges]);
            }
        };

        // Makes sure that if all sibling categories are selected then a parent category gets selected,
        // and afterwards makes sure that if a category is selected then its descendants are not selected.
        const recalculateSelections = function ($parentElement, allCategories, categoriesWithChanges) {

            let somethingChanged = true;
            while (somethingChanged) {
                somethingChanged = false;

                //check siblings, and if all are selected, select the parent
                $parentElement.find("input[type='checkbox']:checked").each(function (index1, checkboxElement) {

                    const containingLi = $(checkboxElement).closest('li');
                    const parentId = $(containingLi).attr('data-parent-id');

                    if (!settings.addCheckboxesToLeafsOnly) {
                        let allSiblingsSelected = true;
                        if ($('li[data-parent-id="' + parentId + '"] input[type="checkbox"]:not(:checked)', $parentElement).toArray().length) {
                            allSiblingsSelected = false;
                        }

                        if (allSiblingsSelected) {
                            $('li[data-category-id="' + parentId + '"] input[type="checkbox"]', $parentElement).each(function (index2, checkboxElement) {
                                $(checkboxElement).prop('checked', 'checked');
                                const containingLi = $(checkboxElement).closest('li');
                                const categoryId = $(containingLi).attr('data-category-id');
                                const category = allCategories.find(x => categoryEquals(x.id, categoryId));
                                category.selected = true;
                                categoriesWithChanges.push(category);
                            });
                            somethingChanged = true;
                        }
                    }
                });

                //for each selected category, deselect all its descendants
                $parentElement.find("input[type='checkbox']:checked").each(function (index1, checkboxElement) {

                    const containingLi = $(checkboxElement).closest('li');
                    const categoryId = $(containingLi).attr('data-category-id');

                    const parentIds = [];
                    parentIds.push(categoryId);

                    while (parentIds.length > 0) {

                        const parentId = parentIds.pop();
                        $('li[data-parent-id="' + parentId + '"]', $parentElement).each(function (index2, childLiElement) {
                            const categoryId = $(childLiElement).attr('data-category-id');
                            parentIds.push(categoryId);
                            $(childLiElement).find("input[type='checkbox']").each(function (index3, checkboxElement) {
                                $(checkboxElement).prop('checked', null);
                                const category = allCategories.find(x => categoryEquals(x.id, categoryId));
                                category.selected = false;
                                categoriesWithChanges.push(category);
                            });
                        });
                    }
                });
            }
        };


        // For each selected category checkbox, makes sure that its ascendants' li elements have the class "has-selected-child"
        const recalculateHasSelectedChild = function ($parentElement, allCategories) {
            // for each selected checkbox...
            $("input[type='checkbox']:checked", $parentElement).each(function (index1, checkboxElement) {

                const containingLi = $(checkboxElement).closest('li');
                let parentId = $(containingLi).attr('data-parent-id');

                // add "has-selected-child-current" to its parent and further ascendants
                let parentFound = true;
                do {
                    parentFound = false;
                    $('li[data-category-id="' + parentId + '"]', $parentElement).each(function (index2, parentLiElement) {
                        parentFound = true;
                        $(parentLiElement).addClass('has-selected-child-current');
                        parentId = $(parentLiElement).attr('data-parent-id');
                    });
                } while (parentFound);
            });
            $("li.has-selected-ancestor-elsewhere", $parentElement).each(function (index1, liElement) {
                const containingLi = $(liElement);
                let parentId = $(containingLi).attr('data-parent-id');

                // add "has-selected-child-current" to its parent and further ascendants
                let parentFound = true;
                do {
                    parentFound = false;
                    $('li[data-category-id="' + parentId + '"]', $parentElement).each(function (index2, parentLiElement) {
                        parentFound = true;
                        $(parentLiElement).addClass('has-selected-child-current');
                        parentId = $(parentLiElement).attr('data-parent-id');
                    });
                } while (parentFound);
            });

            // make sure only "has-selected-child-current" elements are assigned the "has-selected-child" at the end
            $('li.has-selected-child:not(.has-selected-child-current)', $parentElement).removeClass('has-selected-child');
            $('li.has-selected-child-current', $parentElement).addClass('has-selected-child');
            $('li.has-selected-child-current', $parentElement).removeClass('has-selected-child-current');
        };

        // For each selected category checkbox, makes sure that its descendants' li elements have the class "has-selected-ancestor"
        const recalculateHasSelectedAncestor = function ($parentElement, allCategories) {
            // for each selected checkbox...
            $parentElement.find("input[type='checkbox']:checked").each(function (index1, checkboxElement) {

                const containingLi = $(checkboxElement).closest('li');
                const categoryId = $(containingLi).attr('data-category-id');

                const parentIds = [];
                parentIds.push(categoryId);

                // add "has-selected-child-current" to its children and further descendants, and make sure they are not selected too
                while (parentIds.length > 0) {
                    const parentId = parentIds.pop();
                    $('li[data-parent-id="' + parentId + '"]', $parentElement).each(function (index2, childLiElement) {
                        $(childLiElement).addClass('has-selected-ancestor-current');
                        parentIds.push($(childLiElement).attr('data-category-id'));
                    });
                }
            });

            // make sure only "has-selected-ancestor-current" elements are assigned the "has-selected-ancestor" at the end
            $('li.has-selected-ancestor:not(.has-selected-ancestor-current)', $parentElement).removeClass('has-selected-ancestor');
            $('li.has-selected-ancestor-current', $parentElement).addClass('has-selected-ancestor');
            $('li.has-selected-ancestor-current', $parentElement).removeClass('has-selected-ancestor-current');

            // also process "has-selected-ancestor-elsewhere" - this class should be added to aliases of allCategories that have a selected parent
            $('li.has-selected-ancestor-elsewhere', $parentElement).each(function (index1, liElement) { $(liElement).removeClass('has-selected-ancestor-elsewhere'); });
            $('li.has-selected-ancestor', $parentElement).each(function (index1, liElement) {
                const mockSelectedCategoryId = $(liElement).attr('data-category-id');
                const selectedParentId = $(liElement).attr('data-parent-id');

                allCategories.filter(x => categoryEquals(x.id, mockSelectedCategoryId)).forEach(x => {
                    $('li[data-category-id="' + x.id + '"]').each(function (index1, aliasLiElement) {
                        if ($(aliasLiElement).attr('data-parent-id') != selectedParentId) {
                            $(aliasLiElement).addClass('has-selected-ancestor-elsewhere');
                        }
                    });
                });

            });
        };

        // When a checkbox that ".has-selected-ancestor" gets checked
        // (and note that it means it was only mock-checked while it was having that class),
        // it actually means its sibling checkboxes need to be checked instead,
        // and both its parent and the checkbox in question should get unchecked.
        const processHasSelectedAncestorCheckChange = function (allCategories, liElement, $parentElement, categoriesWithChanges) {

            const parentId = $(liElement).attr('data-parent-id');
            const categoryId = $(liElement).attr('data-category-id');
            const category = allCategories.find(x => x.id == categoryId);

            // Select siblings
            $('li[data-parent-id="' + parentId + '"]', $parentElement).each(function (index1, siblingLiElement) {
                $(siblingLiElement).removeClass('has-selected-ancestor');
                const siblingCategoryId = $(siblingLiElement).attr('data-category-id');
                if (siblingCategoryId != categoryId) {
                    const siblingCategory = allCategories.find(x => x.id == siblingCategoryId);
                    siblingCategory.selected = true;
                    categoriesWithChanges.push(siblingCategory);
                    $(siblingLiElement).find("input[type='checkbox']").each(function (index2, checkboxElement) {
                        $(checkboxElement).prop('checked', 'checked');
                    });
                }
            });

            // Untick the checkbox
            $(liElement).find('input[type="checkbox"]').each(function (index1, checkboxElement) {
                $(checkboxElement).prop('checked', null);
            });
            category.selected = false;
            categoriesWithChanges.push(category);

            // Process the parent
            $('li[data-category-id="' + parentId + '"]', $parentElement).each(function (index1, parentLiElement) {
                if ($(parentLiElement).hasClass('has-selected-ancestor')) {
                    processHasSelectedAncestorCheckChange(allCategories, parentLiElement, $parentElement, categoriesWithChanges);
                } else {
                    const parentCategory = allCategories.find(x => x.id == parentId);
                    $(parentLiElement).find('input[type="checkbox"]').each(function (index1, checkboxElement) {
                        $(checkboxElement).prop('checked', null);
                        parentCategory.selected = false;
                        categoriesWithChanges.push(parentCategory);
                    });
                }
            });
        };

        // When we're unticking a category checkbox, we need to untick selected checkboxes for all its aliases too.
        // This is the function that does it.
        const untickAliases = function (checkbox, category, allCategories, $parentElement, categoriesWithChanges) {
            $('li', $parentElement).each(function (index1, liElement) {
                const otherCategoryId = $(liElement).attr('data-category-id');
                if (otherCategoryId != category.id && categoryEquals(otherCategoryId, category.id)) {
                    // if alias category has selected ancestor...
                    if ($(liElement).hasClass('has-selected-ancestor')) {
                        // if alias category has a selected ancestor, process that scenario...
                        processHasSelectedAncestorCheckChange(allCategories, liElement, $parentElement, categoriesWithChanges);
                    }
                    else {
                        // and if alias category has a ticked checkbox, then untick it
                        $(liElement).find('input[type="checkbox"]:checked').each(function (index1, checkboxElement) {
                            const aliasCategoryId = $(liElement).attr('data-category-id');
                            const aliasCategory = allCategories.find(x => x.id == aliasCategoryId);
                            aliasCategory.selected = true;
                            categoriesWithChanges.push(aliasCategory);
                            $(checkbox).prop('checked', null);
                        });
                    }
                }
            });
        };


        // Process a checkboxes getting ticked or unticked
        const checkboxChange = function (checkbox, category, allCategories, $parentElement) {

            const categoriesWithChanges = [];

            if (checkbox.is(':checked')) {
                const containingLi = checkbox.closest('li');

                if (settings.allowIndependentSelection) {
                    category.selected = true;
                    categoriesWithChanges.push(category);
                }
                else {
                    if ($(containingLi).hasClass('has-selected-ancestor')) {
                        // Because checkbox "has selected ancestor", it means that
                        // actually all its siblings should be checked, and our checkbox must be left unchecked;
                        // then its ancestors must be processed with similar logic.
                        processHasSelectedAncestorCheckChange(allCategories, containingLi, $parentElement, categoriesWithChanges);
                        untickAliases(checkbox, category, allCategories, $parentElement, categoriesWithChanges);
                    } else if ($(containingLi).hasClass('has-selected-ancestor-elsewhere')) {
                        // Because checkbox "has selected ancestor elsewhere, it means that
                        // there is one or more aliases of it that "have selected ancestor" -
                        // find them and uncheck them.
                        $('li.has-selected-ancestor', $parentElement).each(function (index1, liElement) {
                            const otherCategoryId = $(liElement).attr('data-category-id');
                            if (categoryEquals(otherCategoryId, category.id)) {
                                processHasSelectedAncestorCheckChange(allCategories, liElement, $parentElement, categoriesWithChanges);
                            }
                        });
                        untickAliases(checkbox, category, allCategories, $parentElement, categoriesWithChanges);
                    } else {
                        // Default scenario of checking the checkbox
                        category.selected = true;
                        categoriesWithChanges.push(category);
                    }
                }
            }
            else {
                // Default scenario of unticking the checkbox
                category.selected = false;
                categoriesWithChanges.push(category);
                untickAliases(checkbox, category, $parentElement, categoriesWithChanges);
            }

            // Trigger a final recalculation (e.g. select aliases where necessary)
            // This includes triggering a 'selectionChange' event which lets the select2 control know about the changes
            recalculate($parentElement, allCategories, categoriesWithChanges);

            return true;
        };


        // For a given list of categories for a given tier (column) of category tree,
        // creates the list elements containing the categories and relevant controls (buttons, checkboxes etc.)
        const constructColumnDOM = function (column, columnCategories, allCategories, $parentElement) {

            // Create the container <ul> element
            const $ul = $('<ul/>', { 'class': 'category-box', 'data-column': column });

            // For each category create a <li> element
            $.each(columnCategories, function (index, category) {
                const li = $('<li/>', {
                    'data-parent-id': category.parentId,
                    'data-category-id': category.id,
                    'data-category-children': !category.leaf,
                    text: category.name
                });

                // if required, add checkboxes to the categories with event handlers
                if (!settings.addCheckboxesToLeafsOnly || category.leaf) {

                    // add the checkbox and its containing label
                    const label = $('<label class="tick-label" />');
                    const checkbox = $('<input/>', {
                        type: 'checkbox',
                        value: category.id,
                        checked: category.selected ? "checked" : null
                    });
                    const span = $('<span class="cb-show" />');
                    label.append(checkbox);
                    label.append(span);
                    li.prepend(label);

                    // add the event handlers
                    checkbox.on('change', function (e) {
                        checkboxChange(checkbox, category, allCategories, $parentElement);
                    });
                }

                li.appendTo($ul); // append the <li> element to the <ul>
            });

            return $ul;
        };


        // Construct the category browser's DOM.
        const constructDom = function ($parentElement, allCategories) {

            // Clear anything that's already in there
            $parentElement.empty();

            if (settings.maxSelectionLength > 0) {
                $parentElement.append($("<div id='maxSelectionLength'>Please choose up to <strong>" + settings.maxSelectionLength + "</strong> categories that your business will appear in.</div>"));
            }

            // Group categories into columns and for each column construct a list
            const columns = allCategories.reduce((acc, category) => {
                (acc[category.column] = acc[category.column] || []).push(category);
                return acc;
            }, {});

            const keys = Object.keys(columns).sort((a, b) => a - b);

            keys.forEach(key => {
                $parentElement.append(constructColumnDOM(key, columns[key], allCategories, $parentElement));
            });


            // Bind to custom reset event
            $parentElement.on('reset', function (e) {
                $parentElement.find("li.highlighted-option").removeClass("highlighted-option");
                $parentElement.find("li.show-option").removeClass("show-option");
                $parentElement.find("ul.collapse-tier").removeClass("collapse-tier");
            });

            // Bind to custom update event
            $parentElement.on('update', function (e, selectedValues) {
                if (!selectedValues) {
                    selectedValues = [];
                }
                // Set the checked state of each checkbox based on selected values
                $parentElement.find("input[type='checkbox']").each(function () {
                    const $checkbox = $(this);
                    const checkboxValue = $checkbox.val();
                    $checkbox.prop('checked', selectedValues.some(x => categoryEquals(x, checkboxValue)) ? 'checked' : null);
                });

                recalculate($parentElement, allCategories);

                if (settings.maxSelectionLength > 0) {
                    if (!selectedValues.length) {
                        $('#maxSelectionLength').html("Please choose up to <strong>" + settings.maxSelectionLength + "</strong> categories that your business will appear in.");
                    }
                    else {
                        $('#maxSelectionLength').html("<strong>" + selectedValues.length + "/" + settings.maxSelectionLength + "</strong> categories selected.");
                    }
                    if (selectedValues.length >= settings.maxSelectionLength) {
                        $('input[type="checkbox"]:not(:checked):not(:disabled)', $parentElement).prop('disabled', 'disabled');
                    } else {
                        $('input[type="checkbox"]:not(:checked):disabled', $parentElement).prop('disabled', null);
                    }
                }
            });

            // Bind to clicks on <li>s
            $parentElement.on('click', 'ul.category-box li', function (e) {

                // Some browsers fire the "click" handler twice when a checkbox in a label is clicked:
                // once for the input itself, and once for its label (or span) around it.
                // Let's ignore the span one for consistency.
                if (e.target.tagName.toLowerCase() == "span") {
                    return;
                }

                let isInputClick = false;
                if (e.target.tagName.toLowerCase() == "input") {
                    isInputClick = true;
                }

                // get all the values from the clicked element
                const $liElement = $(this);
                const column = $liElement.parent().attr('data-column');
                const categoryId = $liElement.attr('data-category-id');
                const isHighlighted = $liElement.hasClass("highlighted-option");

                if (!isInputClick || !isHighlighted) {

                    if (settings.addCheckboxesToLeafsOnly && !isInputClick) {
                        $liElement.find('input').click();
                    }

                    // reset highlighted class on all categories with column greater than or equal to this
                    $("li.highlighted-option", $parentElement).filter(function () {
                        return $(this).parent().attr('data-column') >= (column);
                    }).removeClass("highlighted-option");

                    if (isHighlighted && !isInputClick) {
                        // We are removing the highlight,
                        // so remove show-option class on column greater than this.
                        $("li.show-option", $parentElement).filter(function () {
                            const $shownLiElement = $(this);
                            return $shownLiElement.closest('ul').attr('data-column') > column;
                        }).removeClass("show-option");
                    }
                    else if(!isHighlighted) {
                        // We are adding the highlight
                        // so remove show-option class on column greater than this,
                        // but not for children of the element getting highlighted.
                        $("li.show-option", $parentElement).filter(function () {
                            const $shownLiElement = $(this);
                            if ($shownLiElement.closest('ul').attr('data-column') > column) {
                                if ($shownLiElement.attr('data-parent-id') != categoryId) {
                                    return true;
                                }
                            }
                            return false;
                        }).removeClass("show-option");
                    }

                    // if the element wasn't previously selected, make it so, otherwise deselect it
                    if (!isHighlighted) {
                        $liElement.addClass("highlighted-option");
                    } else {
                        $liElement.removeClass("highlighted-option");
                    }

                    // find selected column
                    const $selectedUl = $("ul", $parentElement).has("li.highlighted-option").last();
                    const selectedCategoryIds = [];
                    const $selection = $("li.highlighted-option", $selectedUl);
                    $selection.each(function () {
                        selectedCategoryIds.push($(this).attr('data-category-id'));
                    });

                    // decide whether to show children
                    if (settings.descendants) {
                        // start with selection and recursively show descendants
                        const recursivelyShow = function ($elements) {
                            $elements.each(function () {
                                const parentId = $(this).attr('data-category-id');
                                const $childElements = $("li[data-parent-id='" + parentId + "']", $parentElement).addClass("show-option");
                                if ($childElements.length) {
                                    recursivelyShow($childElements);
                                }
                            });
                        };

                        recursivelyShow($selection);
                    } else if (selectedCategoryIds.length === 1) {
                        $("li[data-parent-id='" + selectedCategoryIds[0] + "']", $parentElement).addClass("show-option");
                    }

                    // find final shown column
                    const finalShownColumn = $("ul", $parentElement).has("li.show-option").last().attr('data-column');

                    // set collapse-tier class on column less than final shown column
                    $("ul", $parentElement).each(function () {
                        const $this = $(this);
                        if ($this.attr('data-column') < finalShownColumn) {
                            $this.addClass("collapse-tier");
                        } else {
                            $this.removeClass("collapse-tier");
                        }
                    });
                }
            });

            // Support filtering options with a text input
            if (settings.filter) {
                const toggle = function (v) {
                    return v ? 'addClass' : 'removeClass';
                };

                // Bind to keyup on filter text input
                $parentElement.on('input', 'div.category-column input', function (e) {
                    const $input = $(this);
                    const filterText = $input.val().toLowerCase();
                    $input[toggle(filterText)]('x');
                    $input.closest('div.category-column').find('ul.category-box li').each(function () {
                        const $li = $(this);
                        if ($li.text().toLowerCase().indexOf(filterText) >= 0) {
                            $li.removeClass("filtered");
                        } else {
                            $li.addClass("filtered");
                        }
                    });
                }).on('mousemove', 'div.category-column input.x', function (e) {
                    $(this)[toggle(this.offsetWidth - 18 < e.clientX - this.getBoundingClientRect().left)]('onX');
                }).on('click', 'div.category-column input.onX', function (e) {
                    e.preventDefault();
                    $(this).removeClass('x onX').val('').closest('div.category-column').find('ul.category-box li').removeClass("filtered");
                });
            }


            // When the whole DOM is created,
            // recalculate the selections,
            // for example to correctly check aliases
            // and set ".has-selected-ancestor" classes etc.
            recalculate($parentElement, allCategories);
        };


        // Create the whole control based on data provided
        const setData = function (data) {
            if (settings.massageData) {
                data = settings.massageData(data);
            }

            // If the jQuery selector matches multiple elements,
            // the control will be created for each matched element.
            self.each(function () {
                constructDom($(this), data);
            });
        };


        // Initialize (automatically if autoInit is set, or when init() is called)
        let initialized = false;
        self.init = function () {

            // Make sure the control is not initialized already
            if (initialized) {
                return;
            }
            initialized = true;

            // Get and set data, if it should come from an ajax call 
            if (settings.ajax) {
                const ajax = $.extend({
                    success: setData
                }, settings.ajax);

                $.ajax(ajax);
            }
            // Set data, if it should come from settings.data field
            else if (settings.data) {
                setData(settings.data);
            }
        };
        if (settings.autoInit) {
            self.init();
        }


        // Make chainable
        return this;
    };

    $.fn.treeExplorer.defaultEquals = defaultEquals;

})(jQuery);


// Category browser initialization
// To be called in document.ready

// Options should have the following fields:
// $select: $("#@selectId"),
// $picker: $("#@pickerId"),
// $info: $("#@infoId"),
// pickerContainerId: "@pickerContainerId",
// pickerOverlayId: "@pickerOverlayId",
// pickerCloseClass: "@pickerCloseClass",
// preselectedCategories: @Html.Raw(Json.Encode(preselectedCategories)),
// maxSelectionLength: @maxSelectionLength.GetValueOrDefault(0),
// leafsOnly: @leafsOnly.ToString().ToLower(),
// allowIndependentSelection:  @allowIndependentSelection.ToString().ToLower(),
// categoryListUrl: "@Url.HttpRouteUrl("CategoryList", new { locale = cobrand.Locale })",
// categorySearchUrl: "@Url.HttpRouteUrl("CategorySearch", new { locale = cobrand.Locale })"
// allowSuggestions: true
// addSuggestionCallback: function(suggestion) { console.log("New suggestion: " + suggestion); }

window.initializeTreeExplorer = function (options) {

    const categoryEquals = options.equalsFunction == null
        ? $.fn.treeExplorer.defaultEquals
        : options.equalsFunction;

    // attach the category browser to a div below the multi-select box for categories.
    options.$picker.treeExplorer({
        ajax: {
            url: options.categoryListUrl,
        },
        autoInit: false,
        massageData: function (data) {
            // skip "all categories" tier
            data = data.filter(item => item.tier > 0);

            // automaticaly check values selected in the select2
            const selectedValues = options.$select.val();
            if (selectedValues && selectedValues.length) {
                data.forEach(item => {
                    item.selected = selectedValues.some(x => categoryEquals(x, item.id));
                });
            }
            return data;
        },
        addCheckboxesToLeafsOnly: options.leafsOnly,
        maxSelectionLength: options.maxSelectionLength,
        allowIndependentSelection: options.allowIndependentSelection,
        equalsFunction: options.equalsFunction
    });

    // select2 search dropdown
    const getTrailString = function (trailArray) {
        let trail = '';
        if (Array.isArray(trailArray)) {
            for (let i = 0; i < trailArray.length; i++) {
                trail = trail + trailArray[i] + ' → ';
            }
        } else {
            trail = trailArray;
        }
        return trail;
    };

    const formatResults = function (item) {
        if (item.loading) {
            return "";
        }
        if (item.id == -1) {
            return '<span>' + item.name + '</span>';
        }
        const parentCrumbs = item.parentName == null || item.parentName == ""
            || item.parentName.toLowerCase() == "all sectors" || item.parentName.toLowerCase() == "all categories"
            ? ""
            : " in " + item.parentName;
        return '<span><strong>' + item.name + '</strong> <span class="parentCrumbs">' + parentCrumbs + '</span></span>';
    };


    const formatSelected = function (item) {
        if (!item.trail && item.title) {
            // the trail may have been saved in the title property of Options
            item.trail = item.title;
        }
        if (item.trail) {
            const trail = getTrailString(item.trail);
            if (item.name) {
                return '<span><strong>' + item.name + '</strong></span>';
            }
            if (item.text) {
                return '<span><strong>' + item.text + '</strong></span>';
            }
            if (item) {
                return '<span><strong>' + item + '</strong></span>';
            }
        }
        if (item.name) {
            return '<span><strong>' + item.name + '</strong></span>';
        }
        if (item.text) {
            return '<span><strong>' + item.text + '</strong></span>';
        }
        if (item) {
            return '<span><strong>' + item + '</strong></span>';
        }
        return null;
    };

    const escapeMarkup = function (markup) {
        return markup;
    };

    options.$select.select2({
        placeholder: "Search categories...",
        data: options.preselectedCategories,
        ajax: {
            url: options.categorySearchUrl,
            dataType: 'json',
            delay: 250,
            data: function (params) {
                if (params.term && params.term.trim() !== '') {
                    const query = {
                        searchTerm: params.term.trim(),
                        includeAll: false,
                        leafsOnly: options.leafsOnly,
                        limit: 10
                    };
                    return query;
                }
            },
            processResults: function (data, params) {
                // add "View All Categories" every time results are shown
                if (!data || !params || !params.term) {
                    data = [];
                }

                const exploreAllCategories = {
                    id: -1,
                    name: '<strong>View all categories <span class="material-symbols-rounded">open_in_new</span></strong>'
                };
                data.push(exploreAllCategories);
                if (options.allowSuggestions && params && params.term && params.term.trim() !== '') {
                    let canSuggest = true;
                    for (let i = 0; i < data.length; i++) {
                        if (data[i].name.toLowerCase() == params.term.toLowerCase()) {
                            canSuggest = false;
                            break;
                        }
                    }
                    if (canSuggest) {
                        const addSuggestion = {
                            id: -2,
                            name: `Can't find what you're looking for? Suggest a new category: "` + params.term.trim() + `"`,
                            suggestion: params.term.trim()
                        };
                        data.push(addSuggestion);
                    }
                }
                return {
                    results: data
                };
            },
            transport: function (params, success, failure) {
                if (params && params.data && params.data.searchTerm) {
                    var $request = $.ajax(params);

                    $request.then(success);
                    $request.fail(failure);

                    return $request;
                }
                else {
                    success([]);
                    return;
                }
            },
            cache: true
        },
        escapeMarkup: escapeMarkup,
        templateResult: formatResults,
        templateSelection: formatSelected,
        minimumInputLength: 0,
        theme: "bfs",
        maximumSelectionLength: options.maxSelectionLength
    });

    const showTreeExplorer = function (isOnMobile) {
        options.$picker.init();
        options.$picker.setAllowRecalculation(true);
        options.$select.select2('close');
        options.$select.trigger('change');
        if (isOnMobile) {
            location.hash = options.pickerContainerId;
        }
        $('#' + options.pickerOverlayId).show();
        if (options.useColorbox) {
            window.showingBoxId = options.pickerContainerId;
            $.colorbox({
                inline: true,
                open: true,
                height: '95%',
                maxHeight: '600px',
                width: '95%',
                maxWidth: '1000px',
                href: '#' + options.pickerContainerId,
                opacity: 0.7,
                closeButton: false
            });
        } else {
            $('#' + options.pickerContainerId).show();
        }
    };

    const hideTreeExplorer = function (isOnMobile) {
        if (options.useColorbox) {
            $.colorbox.close();
            window.showingBoxId = null;
        } else {
            $('#' + options.pickerContainerId).hide();
        }

        $('#' + options.pickerOverlayId).hide();
        options.$picker.trigger('reset');
        if (location.hash == "#" + options.pickerContainerId) {
            history.back();
        }
        options.$picker.setAllowRecalculation(false);
    };

    // Add click event listener to elements with class ".close"
    $('.' + options.pickerCloseClass).on('click', function () {
        // Hide the category browser
        hideTreeExplorer();
    });

    $(document).on('click', function (event) {
        if (window.showingBoxId !== options.pickerContainerId)
            return;

        // Check if the click target is not within the colorbox
        if (!$(event.target).closest('#' + options.pickerOverlayId).length) {
            // Hide the category browser
            hideTreeExplorer();
        }
    });

    // bind an event to window.onhashchange that to detect when the history state changes
    window.addEventListener("hashchange", (event) => {
        const previousHash = new URL(event.oldURL).hash;
        const newHash = new URL(event.newURL).hash;

        if (previousHash == "#" + options.pickerContainerId) {
            hideTreeExplorer();
        }
    });


    // If "Explore All Categories" is selected, show the category browser
    options.$select.on('select2:selecting', function (e) {
        if (e.params.args.data.id == -1) {
            e.preventDefault();
            const isOnMobile = !$('#onMobileCheck').is(':visible');
            showTreeExplorer(isOnMobile);
            return false;
        }
        else if (e.params.args.data.id == -2) {
            e.preventDefault();
            if (options.addSuggestionCallback && options.allowSuggestions) {
                options.addSuggestionCallback(e.params.args.data.suggestion);
            }
        }
        else {
            return true;
        }
    });

    // When the treeExplorer sends new selections data
    options.$picker.on('selectionChange', function (event, datas) {
        if (!Array.isArray(datas)) {
            datas = [datas];
        }
        let triggerChange = false;

        for (let i = 0; i < datas.length; i++) {
            data = datas[i];

            let selectedValues = options.$select.val();
            // If that id is already selected...
            if (selectedValues && selectedValues.filter(x => categoryEquals(x, data.id)).length) {
                //...and should keep being selected, do nothing.
                if (data.selected) {
                    continue;
                }
                else {
                    // But if it should get unselected, filter it out.
                    selectedValues = selectedValues.filter(x => !categoryEquals(x, data.id));
                    options.$select.val(selectedValues);
                    triggerChange = true;
                    continue;
                }
            }

            // If that id is not selected and should not be selected, do nothing.
            if (!data.selected) {
                continue;
            }

            // If that id is not selected and should get selected, check if a new option needs creating.
            if (options.$select.find('option[value="' + data.id + '"]').length) {
                // If the option is already there, just change the selected values
                if (!selectedValues) {
                    selectedValues = [];
                }
                selectedValues.push(data.id);
                options.$select.val(selectedValues);
                triggerChange = true;
            }
            else {
                // And if the option isn't there, create it
                var newOption = new Option(data.name, data.id, true, true);
                newOption.title = getTrailString(data.trail); // Hack: save trail in the title property of the Option
                options.$select.append(newOption);
                triggerChange = true;
            }
        }

        if (triggerChange) {
            options.$select.trigger('change');
        }
    });

    // Sync select2 selections with category browser
    options.$select.on('change', function () {
        let selectedValues = options.$select.val();
        options.$picker.trigger('update', [selectedValues]);

        if (options.maxSelectionLength > 0) {
            selectedValues = options.$select.val();
            if (selectedValues && selectedValues.length) {
                options.$info.html('You have selected <b>' + selectedValues.length + '/' + options.maxSelectionLength + '</b> categories');
            }
            else {
                options.$info.html('Please choose up to <b>' + options.maxSelectionLength + '</b> categories that your business will appear in');
            }
        }
    });
};

